import React from 'react';
import { AboutStyle,ImageBackStyle } from './styles';

export default function NoPage()
{
    return(
        <>
            <AboutStyle>
                <ImageBackStyle>
                </ImageBackStyle>
            </AboutStyle>
        </>
    )
}